<script setup lang="ts">
// 複数パネルをタブで切り替える小さな入れ物 (チャンネル / アクション)
import { ref } from 'vue'
import { useI18n, type I18nKey } from '@/i18n'

const props = defineProps<{ tabs: { id: string; label: I18nKey }[]; storageKey?: string }>()
const { t } = useI18n()
function initial(): string {
  try {
    const v = props.storageKey ? localStorage.getItem(props.storageKey) : null
    if (v && props.tabs.some(x => x.id === v)) return v
  } catch {
    /* ignore */
  }
  return props.tabs[0]!.id
}
const current = ref(initial())
function select(id: string) {
  current.value = id
  try {
    if (props.storageKey) localStorage.setItem(props.storageKey, id)
  } catch {
    /* ignore */
  }
}
</script>

<template>
  <div class="tabbed">
    <div class="tabs">
      <button v-for="tab in tabs" :key="tab.id" class="tab" :class="{ active: current === tab.id }" @click="select(tab.id)">{{ t(tab.label) }}</button>
    </div>
    <div class="body"><slot :name="current" /></div>
  </div>
</template>

<style scoped>
.tabbed {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}
.tabs {
  display: flex;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
  padding: 2px 6px 0;
  background: var(--bg-2);
  border-bottom: 1px solid var(--line-weak);
}
.tab {
  white-space: nowrap;
  flex: none;
  background: transparent;
  border: none;
  color: var(--fg-2);
  font-size: 11px;
  padding: 4px 8px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.tab.active {
  color: var(--fg-0);
  border-bottom-color: var(--accent);
}
.body {
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.body :deep(.panel-title) {
  display: none;
}
</style>
